import React from 'react';
type SectionHeadingProps = {
  id: string;
  title: string;
  subtitle?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  id,
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={centered ? 'text-center' : ''} data-id="element-1399" data-mp="j2ju0zthgycy">
      <h2 id={id} className="display text-[30px] font-semibold text-ink sm:text-[40px]" data-id="element-1400" data-mp="o4so5zi3e6gn">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 max-w-[620px] text-[16px] leading-[1.5] text-ink-muted ${centered ? 'mx-auto' : ''}`} data-id="element-1401" data-mp="1br8wb269z9qa">
          {subtitle}
        </p>}
    </div>;
}